import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step73 = ({ setStep, setFormdata, formData }) => {
  const [linkedinError, setLinkedinError] = useState(""); // State to hold error message
  const baseLinkedinUrl = "https://linkedin.com/in/";

  // LinkedIn URL validation function
  const validateLinkedinProfile = (url) => {
    const regex = /^https?:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+\/?$/;
    return regex.test(url);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Ensure that the input always starts with the baseLinkedinUrl
    if (inputValue.startsWith(baseLinkedinUrl)) {
      const username = inputValue.replace(baseLinkedinUrl, ""); // Extract the username part
      setFormdata((prevState) => ({
        ...prevState,
        linkedin_profile: `${baseLinkedinUrl}${username}`, // Reconstruct the LinkedIn profile URL
      }));
    }
  };

  const Next = () => {
    if (!formData?.linkedin_profile || !validateLinkedinProfile(formData?.linkedin_profile)) {
      // Set error message if LinkedIn profile URL is invalid
      setLinkedinError("Please enter a valid LinkedIn username (e.g., https://linkedin.com/in/username).");
    } else {
      // Clear error message and proceed to the next step
      setLinkedinError("");
      setStep(8);
    }
  };

  return (
    <>
      <div className="top_logo_block">
        <div className="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div className="step_body">
        <div className="step_form">
          <div className="form_block box_width_md_one">
            <h1>What is your LinkedIn profile?</h1>
            <div className="input_fields">
              <input
                type="text"
                value={formData?.linkedin_profile || baseLinkedinUrl}
                onChange={handleInputChange}
                placeholder={baseLinkedinUrl}
              />
              {linkedinError && <p className="error_txt" style={{ color: "red" }}>{linkedinError}</p>} {/* Display error message */}
              <span className="capt">Add your profile address</span>
            </div>
          </div>
          <div className="btn_block">
            <a onClick={() => setStep(7)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={Next} className="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step73;